/* AURUM 79 · HOT SALE por franjas · Built by SodaLab
   Las franjas se editan en Admin > Contenido > Metaobjetos > "Hot Sale · Franja" (window.SL_HD, ver snippets/sl-hd-data.liquid).
   1) Etiqueta -X% en tarjetas y pagina de producto (.sl-hd) durante la franja de sus colecciones.
   2) Tag "HAPPY HOURS -X%" en el menu (lista de colecciones) SOLO mientras la franja de esa coleccion esta activa.
   El descuento real lo aplica la app; esto solo lo muestra.
   Prueba: agregar ?hd_test=2026-10-16T22:30:00Z (UTC) a la URL para simular una hora. */
(function(){
  var ALL='hot-sale-todo-menos-timeless-gs';   /* coleccion "todo menos Timeless y G&S" */
  var ALL_EXC=['timeless','gems-stones'];
  var test=null; try{ var m=location.search.match(/[?&]hd_test=([^&]+)/); if(m) test=Date.parse(decodeURIComponent(m[1])); }catch(e){}
  function now(){ return Math.floor((test||Date.now())/1000); }
  function data(){ return (window.SL_HD&&window.SL_HD.length)?window.SL_HD:[]; }
  function activeList(){ var t=now(), out=[]; data().forEach(function(f){ if(t>=f.s&&t<f.e) out.push(f); }); return out; }
  function inter(a,b){ for(var i=0;i<a.length;i++){ if(b.indexOf(a[i])>-1) return true; } return false; }
  function pctProduct(handles,act){ var best=0; act.forEach(function(f){ if(f.p>best&&inter(handles,f.c)) best=f.p; }); return best; }
  function pctMenu(h,act){ var best=0; act.forEach(function(f){ var hit=f.c.indexOf(h)>-1||(f.c.indexOf(ALL)>-1&&ALL_EXC.indexOf(h)<0); if(hit&&f.p>best) best=f.p; }); return best; }
  function listed(h){ var d=data(); for(var i=0;i<d.length;i++){ if(d[i].c.indexOf(h)>-1) return true; } return false; }
  function handleOf(a){ var p=((a.getAttribute('href')||'').split('/collections/')[1]||'').split(/[?#]/)[0]; return (!p||p.indexOf('/')>-1)?'':p; }
  /* solo listas del menu que contienen al menos una coleccion de la campana (ej. submenu COLECCIONES) */
  function inCampaignList(a){
    var ul=a.closest('ul, ol'); if(!ul) return false;
    if(ul.dataset.slHh===undefined){
      var ok=false, ls=ul.querySelectorAll('a[href*="/collections/"]');
      for(var i=0;i<ls.length;i++){ if(listed(handleOf(ls[i]))){ ok=true; break; } }
      ul.dataset.slHh=ok?'1':'0';
    }
    return ul.dataset.slHh==='1';
  }
  function css(){
    if(document.getElementById('sl-hh-css')) return;
    var s=document.createElement('style'); s.id='sl-hh-css';
    s.textContent='.sl-hh{display:inline-block;margin-left:10px;padding:4px 6px 3px;background:#E10600;color:#fff;font-size:8.5px;letter-spacing:.14em;line-height:1;font-weight:700;vertical-align:middle;white-space:nowrap;border-radius:2px;text-transform:uppercase}';
    (document.head||document.documentElement).appendChild(s);
  }
  function menu(act){
    var links=document.querySelectorAll('[id*="header"] a[href*="/collections/"], header-sidebar a[href*="/collections/"], .header-sidebar a[href*="/collections/"]');
    for(var i=0;i<links.length;i++){
      var a=links[i], path=handleOf(a), txt='';
      if(path&&path!=='hot-days'&&path!=='todos'&&path!==ALL&&act.length&&(listed(path)||inCampaignList(a))){
        var p=pctMenu(path,act);
        if(p>0) txt='Happy Hours -'+p+'%';
      }
      var b=a.querySelector('.sl-hh');
      if(!txt){ if(b) b.parentNode.removeChild(b); continue; }
      if(!b){ b=document.createElement('span'); b.className='sl-hh'; a.appendChild(b); }
      if(b.textContent!==txt) b.textContent=txt;
    }
  }
  function run(){
    var act=activeList();
    var els=document.querySelectorAll('.sl-hd[data-hd]');
    for(var i=0;i<els.length;i++){
      var el=els[i], p=act.length?pctProduct(el.getAttribute('data-hd').split('|'),act):0;
      var t=p>0?('-'+p+'%'):'';
      if(p>0){ if(el.textContent!==t) el.textContent=t; if(el.hidden) el.hidden=false; } else if(!el.hidden){ el.hidden=true; }
    }
    css(); menu(act);
  }
  var to=null;
  function soon(){ clearTimeout(to); to=setTimeout(run,150); }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
  try{ new MutationObserver(soon).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  setInterval(run,30000);
})();